const allAppActions = {
  'virtualclassroom': {
    'whiteboard/updateTabContent': {'scope': ['local'], 'store': true, 'broadcast': true, 'log': false},
    'whiteboard/addTab': {'scope': ['local'], 'store': true, 'broadcast': true, 'log': false},
    'whiteboard/removeTab': {'scope': ['local'], 'store': true, 'broadcast': true, 'log': false},
    'whiteboard/activateTab': {'scope': ['local'], 'store': true, 'broadcast': true, 'log': false},
    'whiteboard/crudAnnotations': {'scope': ['local'], 'store': true, 'broadcast': true, 'log': false},
    'whiteboard/setTabs': {'scope': ['local', 'breakout'], 'store': true, 'broadcast': false, 'log': false},
    'whiteboard/saveTabs': {'scope': ['local', 'breakout'], 'store': true, 'broadcast': false, 'log': false},
    'whiteboard/setExternalAsset': {'scope': ['local'], 'store': false, 'broadcast': true, 'log': false},
    'whiteboard/addInteraction': {'scope': ['local'], 'store': true, 'broadcast': true, 'log': false},
    'whiteboard/toggleEditable': {'scope': ['local'], 'store': true, 'broadcast': true, 'log': false},
    'whiteboard/changeTabName': {'scope': ['local'], 'store': true, 'broadcast': true, 'log': false},
    'whiteboard/rerenderTab': {'scope': ['local'], 'store': true, 'broadcast': true, 'log': false},
    'whiteboard/updateState': {'scope': ['local'], 'store': true, 'broadcast': true, 'log': false},
    'whiteboard/setPointer': {'scope': ['local'], 'store': false, 'broadcast': true, 'log': false},

    'twilio/toggleTrack': {'scope': ['local'], 'store': true, 'broadcast': true, 'log': false},
    'twilio/toggleAgoraTrack': {'scope': ['local'], 'store': true, 'broadcast': true, 'log': false},
    'twilio/speaking': {'scope': ['local'], 'store': true, 'broadcast': true, 'log': false},
    'twilio/speakingAgora': {'scope': ['local'], 'store': true, 'broadcast': true, 'log': false},

    'classroom/setParticipants': {'scope': ['local'], 'store': true, 'broadcast': true, 'log': false},
    'classroom/setClassMode': {'scope': ['local', 'breakout'], 'store': true, 'broadcast': true, 'log': false},
    'classroom/updateClassStatus': {'scope': ['local'], 'store': true, 'broadcast': true, 'log': true},
    'classroom/changeVideoConfig': {'scope': ['local'], 'store': true, 'broadcast': true, 'log': false},
    'classroom/changeVideoProvider': {'scope': ['local'], 'store': true, 'broadcast': true, 'log': false},
    'classroom/recordingConfirmed': {'scope': ['local'], 'store': true, 'broadcast': false, 'log': false},
    'classroom/changeEntryPolicy': {'scope': ['local'], 'store': true, 'broadcast': true, 'log': false},
    'classroom/updateParticipant': {'scope': ['local', 'breakout'], 'store': true, 'broadcast': true, 'log': false},

    'eventlog/addEvent': {'scope': ['local'], 'store': true, 'broadcast': true, 'log': false},

    'diagnostics/storeTwilioReport': {'scope': ['local'], 'store': true, 'broadcast': true, 'log': false},
    'diagnostics/generateTwilioReport': {'scope': ['local'], 'store': true, 'broadcast': true, 'log': false},

    'breakoutrooms/setUserMap': {'scope': ['broadcast'], 'store': true, 'broadcast': true, 'log': false},
    'breakoutrooms/setOwnUserMap': {'scope': ['broadcast'], 'store': true, 'broadcast': true, 'log': false},

    'chat/addChatMessage': {'scope': ['local'], 'store': true, 'broadcast': true, 'log': false},
    'chat/editChatMessage': {'scope': ['local'], 'store': true, 'broadcast': true, 'log': false},
    'chat/deleteChatMessage': {'scope': ['local'], 'store': true, 'broadcast': true, 'log': false}
  },
  'homework': {
    'chat/addChatMessage': {'scope': ['local'], 'store': false, 'broadcast': true, 'log': false},
    'chat/editChatMessage': {'scope': ['local'], 'store': false, 'broadcast': true, 'log': false},
    'chat/deleteChatMessage': {'scope': ['local'], 'store': false, 'broadcast': true, 'log': false},

    'notes/addNote': {'scope': ['local'], 'store': false, 'broadcast': true, 'log': false},
    'notes/removeNote': {'scope': ['local'], 'store': false, 'broadcast': true, 'log': false},

    'homeworkers/updateParticipant': {'scope': ['local'], 'store': false, 'broadcast': true, 'log': false}
  }
}

export const getActionMutations = (appName) => {
  return allAppActions[appName]
}
